/*
* Copyright 2026 Tecnalia, Basque Research & Technology Alliance (BRTA)
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*
*  SPDX-License-Identifier: Apache-2.0
*/

import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  	providedIn: 'root'
})

export class RoleService {

	private roleSource = new BehaviorSubject<string>('General');
	public currentRole$ = this.roleSource.asObservable();

	setRole(role: string) {
		this.roleSource.next(role);
	}

}